import { SVGAttributes } from 'react';

const Messenger = (props: SVGAttributes<SVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0.012085C18.7606 0.012085 24 4.95922 24 11.6406C24 18.322 18.7606 23.2692 12 23.2692C10.7855 23.2692 9.61932 23.11 8.52555 22.8085C8.31308 22.7506 8.08853 22.7675 7.88571 22.8567L5.50503 23.906C4.88209 24.1785 4.17948 23.7371 4.15775 23.0569L4.09256 20.9246C4.0829 20.6617 3.96459 20.4181 3.76901 20.242C1.43421 18.1556 0 15.1357 0 11.6406C0 4.95922 5.23944 0.012085 12 0.012085ZM19.2048 8.96083C19.5453 8.42535 18.8837 7.81992 18.3791 8.20344L14.5932 11.0738C14.3372 11.2668 13.9847 11.2692 13.7264 11.0762L10.9231 8.9753C10.0829 8.34575 8.88048 8.56766 8.32032 9.4553L4.79517 15.0416C4.45473 15.5771 5.1163 16.1825 5.62093 15.799L9.40926 12.9263C9.66519 12.7333 10.0177 12.7309 10.2761 12.9238L13.0793 15.0247C13.9195 15.6543 15.1219 15.4324 15.6821 14.5447L19.2048 8.96083Z"
            fill="currentColor"
        />
    </svg>
);
export default Messenger;
